import EcoImg from 'eco-design/base/eco-img';
import EcoSpace from 'eco-design/base/eco-space';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import EcoTab from 'eco-design/elements/eco-tab';
import { useState } from 'react';
import styles from './index.module.scss';

import { useGlobal } from '@/utils/useGlobal';
import getLocal from '@/app/utils/i18n';

export default function TabSwriper2() {
    const { useLang } = useGlobal();
    const { locale } = getLocal();
    const { t } = useLang('TrailSeries.tabSwriper2');
    const [activeTab, setActiveTab] = useState(t('tab_title1'));
    const [activeIndex, setActiveIndex] = useState(0);

    let Tabs = [
        {
            title: t('tab_title2'),
            items: [
                {
                    title: t('tab_item2_title1'),
                    desc: t('tab_item2_desc1'),
                    cards: [
                        { name: t('tab_item2_card1_name1'), times: t('tab_item2_card1_time1') },
                        { name: t('tab_item2_card1_name2'), times: t('tab_item2_card1_time2') },
                        { name: t('tab_item2_card1_name3'), times: t('tab_item2_card1_time3') },
                    ],
                    pc: ['us', 'ca'].includes(locale)
                        ? 'https://websiteoss.ecoflow.com/upload/image/1753670875775/tab2_pc_4.png'
                        : 'https://websiteoss.ecoflow.com/figma-uploads/1757479073944-lyqo1w-compressed-18_4%20IMG.jpg',
                    pad: ['us', 'ca'].includes(locale)
                        ? 'https://websiteoss.ecoflow.com/upload/image/1753670874780/tab2_pad_4.png'
                        : 'https://websiteoss.ecoflow.com/figma-uploads/1757479111673-p7icsn-compressed-18_4%20IMG.jpg',
                    h5: ['us', 'ca'].includes(locale)
                        ? 'https://websiteoss.ecoflow.com/upload/image/1753670873437/tab2_h5_4.png'
                        : 'https://websiteoss.ecoflow.com/figma-uploads/1757479122919-ulm22c-compressed-18_4%20IMG.jpg',
                },
            ],
        },
        {
            title: t('tab_title1'),
            items: [
                {
                    title: t('tab_item1_title1'),
                    desc: t('tab_item1_desc1'),
                    cards: [
                        { name: t('tab_item1_card1_name1'), times: t('tab_item1_card1_time1') },
                        { name: t('tab_item1_card1_name2'), times: t('tab_item1_card1_time2') },
                        { name: t('tab_item1_card1_name3'), times: t('tab_item1_card1_time3') },
                    ],
                    note: t('tab_item1_card1_note'),
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1753670875096/tab2_pc_1.png',
                    pad: 'https://websiteoss.ecoflow.com/upload/image/1753670873635/tab2_pad_1.png',
                    h5: 'https://websiteoss.ecoflow.com/upload/image/1753670872880/tab2_h5_1.png',
                },
                {
                    title: t('tab_item1_title2'),
                    desc: t('tab_item1_desc2'),
                    cards: [
                        { name: t('tab_item1_card2_name1'), times: t('tab_item1_card2_time1') },
                        { name: t('tab_item1_card2_name2'), times: t('tab_item1_card2_time2') },
                        { name: t('tab_item1_card2_name3'), times: t('tab_item1_card2_time3') },
                    ],
                    extra: t('tab_item1_card2_note'),
                    pc: ['us', 'ca'].includes(locale)
                        ? 'https://websiteoss.ecoflow.com/upload/image/1753670875397/tab2_pc_2.png'
                        : 'https://websiteoss.ecoflow.com/figma-uploads/1757478940290-phobu4-compressed-18_2%20IMG.jpg',
                    pad: ['us', 'ca'].includes(locale)
                        ? 'https://websiteoss.ecoflow.com/upload/image/1753670874348/tab2_pad_2.png'
                        : 'https://websiteoss.ecoflow.com/figma-uploads/1757479037255-8oyai2-compressed-18_2%20IMG.jpg',
                    h5: ['us', 'ca'].includes(locale)
                        ? 'https://websiteoss.ecoflow.com/upload/image/1753670873044/tab2_h5_2.png'
                        : 'https://websiteoss.ecoflow.com/figma-uploads/1757479050913-txz0ds-compressed-18_2%20IMG.jpg',
                },
                {
                    title: t('tab_item1_title3'),
                    desc: t('tab_item1_desc3'),
                    cards: [
                        { name: t('tab_item1_card3_name1'), times: t('tab_item1_card3_time1') },
                        { name: t('tab_item1_card3_name2'), times: t('tab_item1_card3_time2') },
                    ],
                    pc: ['us', 'ca'].includes(locale)
                        ? 'https://websiteoss.ecoflow.com/figma-uploads/1757643240708-vkvofy-compressed-18_3%20IMG.jpg'
                        : 'https://websiteoss.ecoflow.com/upload/image/1753670875564/tab2_pc_3.png',
                    pad: ['us', 'ca'].includes(locale)
                        ? 'https://websiteoss.ecoflow.com/figma-uploads/1757643259829-qef8jl-compressed-18_3%20IMG.jpg'
                        : 'https://websiteoss.ecoflow.com/upload/image/1753670874508/tab2_pad_3.png',
                    h5: ['us', 'ca'].includes(locale)
                        ? 'https://websiteoss.ecoflow.com/figma-uploads/1757643165721-711iiz-compressed-18_3%20IMG.jpg'
                        : 'https://websiteoss.ecoflow.com/upload/image/1753670873229/tab2_h5_3.png',
                },
            ],
        },
        {
            title: t('tab_title3'),
            items: [
                {
                    title: t('tab_item3_title1'),
                    desc: t('tab_item3_desc1'),
                    cards: [
                        { name: t('tab_item3_card1_name2'), times: t('tab_item3_card1_time2') },
                        { name: t('tab_item3_card1_name3'), times: t('tab_item3_card1_time3') },
                    ],
                    pc: 'https://websiteoss.ecoflow.com/figma-uploads/1756805185712-5jlnvv-compressed-Frame%201000008593.png',
                    pad: 'https://websiteoss.ecoflow.com/figma-uploads/1756805290625-ymupw1-compressed-Frame%201000008593.png',
                    h5: 'https://websiteoss.ecoflow.com/figma-uploads/1756805331265-a8g6al-compressed-Frame%201612707957.png',
                },
                {
                    title: t('tab_item3_title2'),
                    desc: t('tab_item3_desc2'),
                    cards: [
                        { name: t('tab_item3_card2_name1'), times: t('tab_item3_card2_time1') },
                        { name: t('tab_item3_card2_name2'), times: t('tab_item3_card2_time2') },
                        { name: t('tab_item3_card2_name3'), times: t('tab_item3_card2_time3') },
                    ],
                    extra: t('tab_item3_card2_note'),
                    pc: 'https://websiteoss.ecoflow.com/figma-uploads/1756805228941-hgdzve-compressed-Frame%201000008594.png',
                    pad: 'https://websiteoss.ecoflow.com/figma-uploads/1756805298586-9mkm1l-compressed-Frame%201000008594.png',
                    h5: 'https://websiteoss.ecoflow.com/figma-uploads/1756805349795-wr4e1w-compressed-Frame%201612707958.png',
                },
                {
                    title: t('tab_item3_title3'),
                    desc: t('tab_item3_desc3'),
                    cards: [
                        { name: t('tab_item1_card3_name1'), times: t('tab_item1_card3_time1') },
                        { name: t('tab_item1_card3_name2'), times: t('tab_item1_card3_time2') },
                    ],
                    pc: 'https://websiteoss.ecoflow.com/figma-uploads/1756805247307-2iwz11-compressed-Frame%201000008595.png',
                    pad: 'https://websiteoss.ecoflow.com/figma-uploads/1756805309455-qijl2v-compressed-Frame%201000008595.png',
                    h5: 'https://websiteoss.ecoflow.com/figma-uploads/1756805365292-20zda5-compressed-Frame%201612707959.png',
                },
            ],
        },
    ];

    if (!['us', 'ca'].includes(locale)) {
        Tabs = [Tabs[1], Tabs[0]];
    }

    const [selectedItem, setSelectedItem] = useState(Tabs[0]);
    const TabItems = Tabs.map((item) => ({ tabValue: item.title, tabLabel: item.title }));

    const onTabChange = (item: any, index: number) => {
        setActiveTab(item.tabValue);
        setActiveIndex(index);
        setSelectedItem(Tabs[index]);
    };

    return (
        <div className={`page-tabSwriper2 ${styles.TabSwriper2} GtmModuleData-section`} data-section-id="TabSwriper2" id="TabSwriper2">
            <EcoSpace />
            <EcoSectionCommon title={t('title')} desc={t('desc')} />
            <EcoSpaceSmall />
            <div className={`eco-content ${styles.TabSwriper2}`}>
                <div className="tab-container">
                    <div className="tab-wrapper">
                        <div className="item-container">
                            {selectedItem.items.map((item, index) => {
                                return (
                                    <div key={index} className={`card card-${activeIndex}`}>
                                        <div className="content-image">
                                            <EcoImg key={item.pc} pc={item.pc} pad={item.pad} h5={item.h5} />
                                        </div>
                                        <div className="tab-content">
                                            <div className="content-header">
                                                <div className="tab-content-title">{item.title}</div>
                                                <div className="tab-content-desc">{item.desc}</div>
                                            </div>
                                            {['us', 'ca'].includes(locale) ? (
                                                <div className={`content-items content-items-${activeIndex}`}>
                                                    {item.cards.map((card, key) => (
                                                        <div key={key} className={`item ${item.cards.length === 2 && key === 1 ? 'no-right-border' : ''}`}>
                                                            <div className="item-info">
                                                                <div className="item-times">{card.times}</div>
                                                                <div className="item-name">{card.name}</div>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            ) : (
                                                <div className="content-items-eu">
                                                    {item.cards
                                                        .filter((card) => card.name)
                                                        .map((card, key) => (
                                                            <div key={key} className="item">
                                                                <div className="item-info">
                                                                    <div className="item-times">{card.name}</div>
                                                                    <div className="item-name">{card.times}</div>
                                                                </div>
                                                            </div>
                                                        ))}
                                                </div>
                                            )}

                                            {item.extra && <div className="extra">{item.extra}</div>}
                                            {item.note && <div className="note">{item.note}</div>}
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>

                    <div className="tab-headers">
                        <EcoTab activeKey={activeTab} gtmTitle={t('title')} items={TabItems} onChange={onTabChange} />
                    </div>
                    <div className="tip">{t('tip')}</div>
                </div>
            </div>
        </div>
    );
}
